import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ClientContactUserCard from "./ClientContactUserCard";
import {
  getCurrentUserName,
  searchClientUsersMaster,
  updateClientUsersMaster,
} from "../Actions/ClientContactUserAPI";
import { mapClientUserFromApi, uiRoleToApi } from "../helpers/clientContactUserRole";
import { showClientUserRouteNotify, showClientUserToast } from "../helpers/clientContactUserNotify";
import "./UserManagementMaster.css";

const PAGE_SIZE = 15;

class ClientContactUserManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Name: "",
        Email: "",
        Phone: "",
        Role: "",
        PageNumber: 1,
        PageSize: PAGE_SIZE,
      },
      users: [],
      pagination: {
        totalcount: 0,
        pageSize: PAGE_SIZE,
        currentPage: 1,
      },
      loading: false,
    };
    this.SearchData = this.SearchData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.loadUsers = this.loadUsers.bind(this);
    this.deleteUserList = this.deleteUserList.bind(this);
  }

  componentDidMount() {
    const { t, history, location } = this.props;
    showClientUserRouteNotify(history, location);
    this.props.dispatch({
      type: "SubBannerTitle",
      data: t("ClientContactUserManagementContent.Title").toUpperCase(),
    });
    this.loadUsers();
  }

  loadUsers(pageNumber) {
    const searchData = {
      ...this.state.searchData,
      PageNumber: pageNumber || this.state.searchData.PageNumber,
    };

    this.setState({ loading: true, searchData });

    searchClientUsersMaster(searchData)
      .then((response) => {
        const result = response.data || {};
        const users = (result.data || []).map(mapClientUserFromApi);
        const pagination = result.pagination || {
          totalcount: users.length,
          pageSize: searchData.PageSize,
          currentPage: searchData.PageNumber,
        };

        this.setState({
          users,
          pagination,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ users: [], loading: false });
        showClientUserToast.error(this.props.t("CommonText.500ErrorMessage"));
      });
  }

  SearchData() {
    this.loadUsers(1);
  }

  handlePageChange(pageNumber) {
    this.loadUsers(pageNumber);
  }

  ClearInput() {
    this.setState(
      {
        searchData: {
          Name: "",
          Email: "",
          Phone: "",
          Role: "",
          PageNumber: 1,
          PageSize: PAGE_SIZE,
        },
      },
      () => this.loadUsers(1)
    );
  }

  handleInputChange(e) {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        [name]: value,
      },
    }));
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "ClientContactUserDetails", data: item });
    history.push(`/Home/Management/Users/ClientContacts/Edit/${item.id}`);
    window.scrollTo(0, 0);
  }

  deleteUserList(item) {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const payload = {
              clientUsersMasterId: item.clientUsersMasterId || item.id,
              role: uiRoleToApi(item.role) || item.roleName,
              name: item.name,
              email: item.email,
              phone: item.phone || "",
              address: item.address || "",
              isDeleted: true,
              modifiedBy: getCurrentUserName(),
            };

            updateClientUsersMaster(payload)
              .then((response) => {
                if (response.data === "Deleted") {
                  showClientUserToast.success(t("CommonText.CommonDelete"));
                  this.loadUsers(this.state.searchData.PageNumber);
                  return;
                }
                showClientUserToast.error(response.data || t("CommonText.500ErrorMessage"));
              })
              .catch(() => {
                showClientUserToast.error(t("CommonText.500ErrorMessage"));
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
        },
      ],
    });
  }

  handleAddUser() {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "ClientContactUserDetails", data: null });
    history.push("/Home/Management/Users/ClientContacts/Add");
    window.scrollTo(0, 0);
  }

  renderFilterField(label, name, placeholder, iconClass, type = "text") {
    return (
      <div className="col-lg-3 col-md-6 um-filter-field">
        <label className="form-label">{label}</label>
        <div className="um-input-shell">
          <span className="um-input-icon">
            <i className={`fa ${iconClass}`} aria-hidden="true"></i>
          </span>
          <input
            className="form-control"
            type={type}
            name={name}
            placeholder={placeholder}
            value={this.state.searchData[name]}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
    );
  }

  renderRoleFilter(t) {
    return (
      <div className="col-lg-3 col-md-6 um-filter-field">
        <label className="form-label">
          {t("ClientContactUserManagementContent.Role")}
        </label>
        <div className="um-input-shell">
          <span className="um-input-icon">
            <i className="fa fa-briefcase" aria-hidden="true"></i>
          </span>
          <div className="um-select-wrap">
            <select
              className="form-control um-select"
              name="Role"
              value={this.state.searchData.Role}
              onChange={this.handleInputChange}
            >
              <option value="">
                {t("ClientContactUserManagementContent.AllRoles")}
              </option>
              <option value="FM">
                {t("ClientContactUserManagementContent.FM")}
              </option>
              <option value="TSI">
                {t("ClientContactUserManagementContent.TSI")}
              </option>
              <option value="TE">
                {t("ClientContactUserManagementContent.TE")}
              </option>
            </select>
            <i className="fa fa-chevron-down um-select-chevron" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { showSidePane, t } = this.props;
    const { users, pagination, loading } = this.state;

    return (
      <div className="full-height user-module-master">
        <div className="pt-3">
          <div className="row">
            <div className="col-12">
              <div className="um-section">
                <div className="um-section-header">
                  <h5 className="um-section-title">
                    <i
                      className="fa fa-filter um-section-title-icon"
                      aria-hidden="true"
                    ></i>
                    {t("ClientContactUserManagementContent.SearchFilters")}
                  </h5>
                </div>
                <div className="um-section-body">
                  <div className="row um-filter-grid">
                    {this.renderFilterField(
                      t("EquipmentManagementScreenContent.Name"),
                      "Name",
                      t("EquipmentManagementScreenContent.Name"),
                      "fa-user-circle"
                    )}
                    {this.renderFilterField(
                      t("ServicedByScreenContent.Email"),
                      "Email",
                      t("ServicedByScreenContent.Email"),
                      "fa-envelope-o",
                      "email"
                    )}
                    {this.renderFilterField(
                      t("ClientManagementScreenContent.Phone"),
                      "Phone",
                      t("ClientManagementScreenContent.Phone"),
                      "fa-phone"
                    )}
                    {this.renderRoleFilter(t)}
                  </div>
                  <div className="um-actions">
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-btn um-btn-primary"
                      type="button"
                      onClick={this.SearchData}
                      disabled={loading}
                    >
                      {t("content.Search")}
                    </button>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn um-btn um-btn-secondary"
                      type="button"
                      onClick={this.ClearInput}
                      disabled={loading}
                    >
                      {t("content.Clear")}
                    </button>
                  </div>
                </div>
              </div>

              <div className="um-section">
                <div className="um-section-header">
                  <h5 className="um-section-title">
                    <i
                      className="fa fa-users um-section-title-icon"
                      aria-hidden="true"
                    ></i>
                    {t("ClientContactUserManagementContent.Title")}
                  </h5>
                  <button
                    type="button"
                    className="um-header-add-btn"
                    onClick={() => this.handleAddUser()}
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i>
                    <span>{t("ShipManagementContent.Add")}</span>
                  </button>
                </div>
                <div className="um-list-body">
                  <ClientContactUserCard
                    currentPage={pagination.currentPage || 1}
                    arraylist={users}
                    pageSize={pagination.pageSize || PAGE_SIZE}
                    totalRecords={pagination.totalcount || 0}
                    setUpdatedState={(value) => this.handlePageChange(value)}
                    eyeclick={(item) => this.eyeclick(item)}
                    deleteUserList={(item) => this.deleteUserList(item)}
                    showSidePane={showSidePane}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientContactUserManagement))
);
